import { createSlice } from "@reduxjs/toolkit";
import { checkSupplierPassword, ForgetPasswordAction, login, ResetPassword } from "./authActions";


const initialState = {
  name: null,
  token: null,
  error: null,
  loading: false,
  isAuthenticated: false,
  email: ''
};


const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.name = null
      state.token = null
      state.error = null
      state.loading = false
      state.isAuthenticated = false
    },

    setEmail: (state, { payload }) => {
      state.email = payload
    }
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(login.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state: any, action: any) => {
        const { id, accessToken,email } = action.payload.data;
        
        localStorage.setItem('token', accessToken);
        localStorage.setItem("id", id);
        localStorage.setItem("email", email);
        state.loading = false
        state.isAuthenticated = true
        state.token = accessToken
        state.email = email;
      })
      .addCase(login.rejected, (state: any, action: any) => {
        state.error = action.payload.error;
        state.loading = false;
      })
      .addCase(checkSupplierPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkSupplierPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.hasPassword = action.payload ?? false; 
            })
      .addCase(checkSupplierPassword.rejected, (state, action) => {
        state.loading = false;
        state.hasPassword = null;
        state.error = action.payload?.error || "Supplier code check failed";
      });
  }
});

const forgetPassword = createSlice({
  name: 'forgetPassword',
  initialState,
  reducers: {
  

    
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(ForgetPasswordAction.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(ForgetPasswordAction.fulfilled, (state: any, action: any) => {
      
        state.loading = false
      })
      .addCase(ForgetPasswordAction.rejected, (state: any, action: any) => {
        state.error = action.payload.error;
        state.loading = false;
      })

  }
});

const resetPassword = createSlice({
  name: 'resetPassword',
  initialState,
  reducers: {
  

    
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(ResetPassword.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(ResetPassword.fulfilled, (state: any, action: any) => {
      
        state.loading = false
      })
      .addCase(ResetPassword.rejected, (state: any, action: any) => {
        state.error = action.payload.error;
        state.loading = false;
      })

  }
});

export const { logout, setEmail } = authSlice.actions;

export const authReducer = authSlice.reducer;
export const forgetPasswordReducer = forgetPassword.reducer
export const resetPasswordReducer = resetPassword.reducer